export default {
  namespaced: true,
  brigades: {
     title: "Brigada | Brigadas",
    name: "Nombre",
    division: "División",
    floor: "Piso",
    type_category: "Categoría",
    number_floors: "Número de Pisos",
    capacity: "Capacidad",
    role: "Rol",
    user: "Usuario",
    filter_by_floor: "Filtrar por Piso",
    filter_by_role: "Filtrar por Rol",
    filter_by_search: "Buscar",
    filter_by_search_placeholder: "Usuario o SOEID",
    status: "Estado",
    courses_uploaded: "Capacitaciones subidas",
    courses_skipped: "Capacitaciones omitidas",
  },
};
